import req from '../req'

// 表单管理 - 表单模板列表
export function getPagesTemplateList (params) {
  return req.get('/forms/template/list', params)
}

// 表单管理-模板创建接口
export function savePagesTemplate (params) {
  return req.post('/forms/activity/activityTemplate', params)
}

// 表单管理 - 表单模板详情接口
export function getPagesTemplateDetail (params) {
  return req.get('/forms/activity/activityTemplate', params)
}
